// extracted by mini-css-extract-plugin
module.exports = {"Wysiwyg":"styles_Wysiwyg__jiFns","title":"styles_title__Y9Y6B","text":"styles_text__B88_B","discoverMore":"styles_discoverMore__AOyWn"};